import { render, staticRenderFns } from "./TicketsGroupAdmin.vue?vue&type=template&id=3198ae4f&"
import script from "./TicketsGroupAdmin.vue?vue&type=script&lang=js&"
export * from "./TicketsGroupAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports